module.exports = __webpack_public_path__ + "static/media/yikatong_zqgq.8e07a837.jpg";